import $ from 'jquery';
import 'slick-carousel';

ready(qs('.CP-more-jobs-wrapper'), () => {
    const $wrapper = $('.CP-more-jobs-wrapper ul');
    const settings_d = {
        nextArrow: '.CP-slider-btn-right',
        prevArrow: '.CP-slider-btn-left',
        dots: false,
        variableWidth: true,
        slidesToShow: 3
    }
    const settings_m = {
        arrows: false,
        dots: false,
        variableWidth: true,
    }
    if (window.innerWidth < 1024) $wrapper.slick(settings_m);
    else $wrapper.slick(settings_d);
    setTimeout(() => {
        for (let i = 0; i < qsa('.CP-more-jobs-wrapper ul li p').length; i++) {
            qsa('.CP-more-jobs-wrapper ul li p')[i].style.overflow = 'hidden';
            
        }
    }, 1500);
})

// window.onresize = () => {
//     if (window.innerWidth > 1024) {
//         if (wrapper.hasClass('slick-initialized')) wrapper.slick('unslick');
//         return
//     }
//     if (!wrapper.hasClass('slick-initialized')) wrapper.slick(settings);
// };
ready(qs('.CP-more-jobs-wrapper-plus-btn'), () => {
    qsa('.CP-job-regular-bloc')[0].style.display = "block";
    qsa('.CP-job-regular-bloc')[1].style.display = "block";
    ael(qs('.CP-plus.CP-more-jobs-wrapper-plus-btn'), 'click', () => {
        qsa('.CP-job-regular-bloc').forEach(el => {
            el.style.display = "block";
            
        });
        qs('.CP-plus.CP-more-jobs-wrapper-plus-btn').style.display = 'none'
    })
})





// WEBPACK FOOTER //
// ./src/scripts/components/MoreJobs.js